<template>

  <ModalContainer queryParam="editProcess" ref="modalEditProceso" size="lg">
    <h3 class="text-center my-2">Editar Procedimiento Enviado</h3>

    <FormAddProcesos
      v-if="indexToEdit"
      :procesosList="procesosList"
      :indexToEdit="indexToEdit"
      @closeModal="cerrarModal"
    />

  </ModalContainer>
  
</template>

<script>
import { ModalContainer } from '@/shared/components';
import FormAddProcesos from './FormAddProcesos.vue';

export default {

  name: "EditarEnvioProceso",

  props: {

    procesosList: {
      type: Array,
      required: true
    }
  },

  components: {
    ModalContainer,
    FormAddProcesos
  },


  created() {
    this.setIndexToEdit()
  },


  data() {

    return {
      indexToEdit: null,
    }
  },

  methods: {

    setIndexToEdit(){
      this.indexToEdit = this.$route.query.editProcess
    },

    cerrarModal(){
      this.$refs.modalEditProceso.closeModal();
    }
  },


  watch:{
    '$route.query.editProcess':{
      handler(){
        this.setIndexToEdit()
      }
    }
  }
}
</script>
